export const environment = {
  production: false,
  env:'Testing',
  HomeTitle:'Comeca - Testing environment',
  ApiUrl: 'https://gcjpiapitest.clavisco.com/',
  recatpchaSiteKey: '6Le4V6QrAAAAAClRqFhv37b_LK8ZFdM325HZPeiz',
  LogRocketId: ''
};
